import React, {useEffect, useState} from 'react';
import onClickOutside from 'react-onclickoutside';
import {addPrefix} from "../../utils/UriUtil";
import {jsonResponseHandler, revenueResponseHandler} from "../../utils/FetchHelper";
import {useDispatch} from "react-redux";
import classnames from "classnames";

const Tip = ({tip}) => {
  return (
    <a onClick={() => window.open(tip.link)} className="box_blog box_blog_type2">
      {tip.type === 'tistory' &&
      <div className="thumb_cite thumb_tistory">
        <span className="ico_blog ico_tistory_type1">티스토리</span>
      </div>
      }
      {tip.type === 'adfit' &&
      <div className="thumb_cite thumb_A">
        <span className="typo_cite">A</span>
      </div>
      }
      {tip.type === 'adsense' &&
      <div className="thumb_cite thumb_G">
        <span className="typo_cite">G</span>
      </div>
      }
      {tip.type === 'dable' &&
      <div className="thumb_cite thumb_D">
        <span className="typo_cite">D</span>
      </div>
      }
      {tip.type === 'tenping' &&
      <div className="thumb_cite thumb_T">
        <span className="typo_cite">T</span>
      </div>
      }
      <div className="cont_info">
        <strong className="tit_cont">{tip.title}</strong>
        <span className="txt_type1">{tip.blogTitle}</span>
        {tip.userName &&
        <span className="txt_type2">by {tip.userName}</span>
        }
      </div>
    </a>
  )
};

const RevenueTips = ({selectable, vendor = 'all'}) => {
  const dispatch = useDispatch();
  const [selectOn, setSelectOn] = useState(false);
  const [filterVendor, setFilterVendor] = useState(vendor);
  const [tips, setTips] = useState([]);
  const [filteredTips, setFilteredTips] = useState([]);
  const [pagedTips, setPagedTips] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const handleChangeVendorFilter = (vendor) => {
    setFilterVendor(vendor);
    setSelectOn(false);
  };
  const handleClickPage = (i) => {
    setPage(i);
    setPagedTipsByPage(i);
  };
  const handleClickLeftButton = () => {
    if (page === 1) {
      return;
    }
    setPage(page - 1);
    setPagedTipsByPage(page - 1);
  };
  const handleClickRightButton = () => {
    if (page === totalPage) {
      return;
    }
    setPage(page + 1);
    setPagedTipsByPage(page + 1);
  };
  const fetchRevenueTips = () => {
    fetch(addPrefix("/manage/revenue/tip.json"), {
      credentials: "include",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(revenueResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        setTips(data.data);
      })
      .catch(e => {
        console.error(e);
      });
  };

  const filterTips = (vendor) => {
    if (vendor === 'all') {
      setFilteredTips(tips);
    } else {
      const filtered = tips.filter((tip) => tip.type === vendor);
      setFilteredTips(filtered);
    }
  };

  const setPagedTipsByPage = (page) => {
    const startIndex = (page - 1) * 6;
    setPagedTips(filteredTips.slice(startIndex, startIndex + 6));
  };

  const getLabelByVendor = (vendor) => {
    if (vendor === 'all') {
      return '전체';
    } else if (vendor === 'tistory') {
      return '사용법 안내';
    } else if (vendor === 'adsense') {
      return '애드센스';
    } else if (vendor === 'adfit') {
      return '애드핏';
    }
  };

  const FilterButton = () => {
    FilterButton.handleClickOutside = () => setSelectOn(false);
    return (
      <div className={classnames('opt_blog', selectOn ? 'opt_open' : '')}>
        <button type="button" className="btn_opt" onClick={() => setSelectOn(!selectOn)}>
          {getLabelByVendor(filterVendor)}<span className="ico_blog ico_open"/>
        </button>
        <span className="txt_change">
                    변경중<span className="ico_blog ico_change"/>
                </span>
        <div className="layer_opt">
          <ul className="list_opt">
            <li onClick={() => handleChangeVendorFilter('all')}>
              <label className="lab_btn">
                전체<input type="button" className="btn_g" value="전체"/>
              </label>
            </li>
            <li onClick={() => handleChangeVendorFilter('tistory')}>
              <label className="lab_btn">
                사용법 안내<input type="button" className="btn_g" value="사용법 안내"/>
              </label>
            </li>
            <li onClick={() => handleChangeVendorFilter('adfit')}>
              <label className="lab_btn">
                애드핏<input type="button" className="btn_g" value="애드핏"/>
              </label>
            </li>
            <li onClick={() => handleChangeVendorFilter('adsense')}>
              <label className="lab_btn">
                애드센스<input type="button" className="btn_g" value="애드센스"/>
              </label>
            </li>
          </ul>
        </div>
      </div>
    )
  };
  const clickOutsideConfig = {
    handleClickOutside: () => FilterButton.handleClickOutside
  };
  const FilterButtonWithEvent = onClickOutside(FilterButton, clickOutsideConfig);

  useEffect(() => {
    const totalPage = Math.ceil(filteredTips.length / 6);
    setTotalPage(totalPage === 0 ? 1 : totalPage);
    setPage(1);
    setPagedTipsByPage(1);
  }, [filteredTips]);
  useEffect(() => {
    filterTips(filterVendor);
  }, [tips, filterVendor]);
  useEffect(() => {
    fetchRevenueTips();
  }, []);
  return (
    <div className="revenue_tip">
      <h4 className="tit_cont">수익을 위한 팁</h4>
      {selectable &&
      <FilterButtonWithEvent/>
      }
      <div className="list_box list_box_type1">
        {
          pagedTips.map((tip, index) => <Tip key={index} tip={tip}/>)
        }
      </div>
      <div className="wrap_paging">
        <strong className="screen_out">현재 1페이지</strong>
        <a className={classnames('link_paging', page === 1 ? '' : 'on')} onClick={handleClickLeftButton}>
          <span className="ico_blog ico_prev">이전 페이지</span>
        </a>
        <ul className="list_paging">
          {
            Array.from({length: totalPage}, (x, i) => i).map((i) => {
              return (
                <li className={i + 1 === page ? 'on' : ''} key={i}>
                  <a className="link_num" onClick={() => handleClickPage(i + 1)}>{i + 1}</a>
                </li>
              )
            })
          }
        </ul>
        <a className={classnames('link_paging', page === totalPage ? '' : 'on')} onClick={handleClickRightButton}>
          <span className="ico_blog ico_next">다음 페이지</span>
        </a>
      </div>
    </div>
  )
};

export default RevenueTips;